module.exports = __webpack_public_path__ + "static/img_1275-5ab784628c76e31780d3efc5f50a192a.webp";